import { Button } from '@shared/components';
import { useAuthContext } from '@shared/contexts/useAuthContext';
import { useNavigate } from 'react-router-dom';
import { Auth0Message } from './types';

type HandleTokenFn = (token: string) => void;
type HandleMessageFn = (message: Auth0Message) => void;

export function Auth0LoginButton() {
  const { setToken } = useAuthContext();
  const navigate = useNavigate();

  const handleToken = (token: string) => {
    setToken(token);
    navigate('/');
  };

  return (
    <div className="mt-4 flex w-full flex-wrap text-gray-700">
      <Button onPress={() => displayAuth0Login(handleToken)} className="w-full">
        Sign in another way
      </Button>
    </div>
  );
}

const displayAuth0Login = (handleToken: HandleTokenFn) => {
  const state = Math.random().toString(36).substring(2);
  const url = `${import.meta.env.VITE_APP_BASE_URL}/auth0-login?state=${state}`;

  const handleMessage: HandleMessageFn = (message: Auth0Message) => {
    console.log('Received message from Auth0 dialog', message);
    if (message.state !== state) {
      console.error('State mismatch in Auth0 response', {
        expected: state,
        received: message.state,
      });
      return;
    }
    handleToken(message.accessToken);
  };

  Office.context.ui.displayDialogAsync(
    url,
    { height: 60, width: 30 },
    (result) => {
      const dialog = result.value;
      dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) =>
        handleDialogMessage(dialog, arg, handleMessage)
      );
    }
  );
};

type DialogMessageArg = { message: string } | { error: number };

const handleDialogMessage = (
  dialog: Office.Dialog,
  arg: DialogMessageArg,
  handleMessage: HandleMessageFn
) => {
  if ('error' in arg) {
    console.error('Dialog error: ' + arg.error);
    return;
  }

  try {
    const message: Auth0Message = JSON.parse(arg.message);
    handleMessage(message);
    dialog.close();
  } catch (e) {
    console.log('Message from dialog: ' + arg.message);
  }
};
